import PropTypes from 'prop-types'
import { Button } from 'antd'
import { FileSearchOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { createUseStyles } from 'react-jss'
import { formatDOB } from '../../lib/datetime'
import { toPath } from '../../routes'
import PatientEntry from '../Common/PatientEntry'

const useStyles = createUseStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  name: {
    fontWeight: 600,
    fontSize: 15,
    minWidth: 0,
    overflowWrap: 'anywhere',
    // PatientEntry sets the link to nowrap for the desktop table; on mobile we
    // let a long name wrap instead of overflowing.
    '& a': {
      whiteSpace: 'normal !important',
    },
  },
  line: {
    fontSize: 13,
    color: '#595959',
    overflowWrap: 'anywhere',
  },
  lineIcon: {
    marginRight: 6,
    color: '#6b6b6b',
  },
})

// Every desktop column fits on the card, so these rows need no expand toggle.
export default function MissedTransmissionMobileCard({ missedTransmission }) {
  const classes = useStyles()
  const { comment, device, id, patient } = missedTransmission
  // formatDOB(undefined) would render today's date, so only format a real value.
  const dob = patient?.birthDate ? formatDOB(patient.birthDate) : null
  const detailLine = [dob, device?.deviceModel?.deviceType?.name]
    .filter(Boolean)
    .join(' · ')

  return (
    <div className={classes.card}>
      <div className={classes.name}>
        {patient ? <PatientEntry patient={patient} /> : '—'}
      </div>
      {detailLine && <div className={classes.line}>{detailLine}</div>}
      {comment && (
        <div className={classes.line}>
          <InfoCircleOutlined className={classes.lineIcon} />
          {comment}
        </div>
      )}
      <div>
        <Link to={toPath.missedTransmissions.missedTransmission({ id })}>
          <Button
            type="link"
            size="small"
            icon={<FileSearchOutlined />}
            style={{ paddingLeft: 0 }}
          >
            Comments / More
          </Button>
        </Link>
      </div>
    </div>
  )
}

MissedTransmissionMobileCard.propTypes = {
  missedTransmission: PropTypes.shape({
    id: PropTypes.string.isRequired,
    comment: PropTypes.string,
    patient: PropTypes.shape({
      birthDate: PropTypes.string,
    }),
    device: PropTypes.shape({
      deviceModel: PropTypes.shape({
        deviceType: PropTypes.shape({
          name: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
}
